import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  ClickAwayListener,
  FormControl,
  FormHelperText,
  TextField,
} from '@mui/material';
import { appTimePicker, error } from './../../../assets/styles/appStyles';
import { useEffect, useRef, useState } from 'react';

const AppTimePicker = ({
  keyName,
  value,
  onChange,
  errorMsg,
  label,
  fieldLabel,
  disabled,
  close,
  onOpenHandler,
}: {
  onChange?: (value: string | null) => void;
  value: any;
  keyName: string;
  errorMsg?: string;
  label: string;
  fieldLabel: string;
  disabled?: boolean;
  close?: boolean;
  onOpenHandler?: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const timePickerRef = useRef(null);

  useEffect(() => {
    if (close != null && !disabled) setIsOpen(!close);
    return () => {
      setIsOpen(false);
    };
  }, [close, disabled]);

  // Normalize incoming value (string or Date)
  let parsedValue: Date | null;

  if (typeof value === 'string' && value) {
    const [hours, minutes] = value.split(':').map(Number);
    parsedValue = new Date();
    parsedValue.setHours(hours, minutes, 0, 0);
  } else if (value instanceof Date) {
    parsedValue = value;
  } else {
    parsedValue = null;
  }

  // Convert picked value back to "HH:mm" in local time
  const handleChange = (date: Date | null) => {
    if (onChange) {
      const formatted =
        date instanceof Date && !Number.isNaN(date.getTime())
          ? `${date.getHours().toString().padStart(2, '0')}:${date
            .getMinutes()
            .toString()
            .padStart(2, '0')}`
          : null;
      onChange(formatted);
    }
  };


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl fullWidth sx={appTimePicker}>
        <ClickAwayListener
          onClickAway={() => {
            setIsOpen(false);
          }}
        >
          <div ref={timePickerRef}>
            <TimePicker
              label={fieldLabel}
              InputProps={{
                name: keyName,
                id: keyName,
                type: 'time',
              }}
              onChange={handleChange}
              value={parsedValue}
              disabled={disabled}
              open={isOpen}
              onOpen={() => (onOpenHandler ? onOpenHandler() : {})}
              renderInput={(params: any) => (
                <TextField
                  id={keyName}
                  data-testid={keyName}
                  label={label}
                  name={keyName}
                  variant="outlined"
                  onKeyDown={(e) => {
                    e.preventDefault();
                    setIsOpen(!isOpen && !disabled);
                    if (onOpenHandler) onOpenHandler();
                  }}
                  onClick={() => {
                    setIsOpen(!isOpen && !disabled);
                    if (onOpenHandler) onOpenHandler();
                  }}
                  inputProps={{
                    maxLength: 150,
                  }}
                  error={!!errorMsg}
                  {...params}
                />
              )}
            />
            {errorMsg ? (
              <FormHelperText sx={error}>{errorMsg}</FormHelperText>
            ) : null}
          </div>
        </ClickAwayListener>
      </FormControl>
    </LocalizationProvider>
  );
};

export default AppTimePicker;
